var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Amplify, Analytics, Auth } from 'aws-amplify';
import { Platform } from 'react-native';
import { NativeModules, DeviceInfo } from '../compatibility';
import { awsmobile } from '../config/awsmobileconfig';
import MetricAttributes from './MetricAttributes';
import GlobalMetricAttributes from './GlobalMetricAttributes';
import { Log } from '../logging/Log';
import TENANT_ID from '../config/TenantId';
import { LogLevel } from '../logging';
import { AZLogTenant } from '../compatibility/NativeModules/Logging/LoggingSupport';
import { errorToLogObject } from '../util';
const logger = Log(TENANT_ID);
let isConfigured = false;
function configured() {
    return isConfigured;
}
function setConfigured(value) {
    isConfigured = value;
}
const constructAmplifyConfiguration = (bundleVersion) => __awaiter(void 0, void 0, void 0, function* () {
    const amplifyConfig = Object.assign({}, awsmobile);
    amplifyConfig.AWSPinpoint.endpoint.attributes = { BundleVersion: [bundleVersion] };
    amplifyConfig.AWSPinpoint.endpoint.demographic.appVersion = DeviceInfo.getVersion();
    amplifyConfig.AWSPinpoint.endpoint.demographic.model = DeviceInfo.getModel();
    amplifyConfig.AWSPinpoint.endpoint.demographic.platformVersion = DeviceInfo.getSystemVersion();
    const manufacturer = yield DeviceInfo.getManufacturer()
        .catch((e) => logger.error(`Error in DeviceInfo.getManufacturer():${JSON.stringify(e)}`));
    if (manufacturer) {
        amplifyConfig.AWSPinpoint.endpoint.demographic.make = manufacturer;
    }
    const anonymousDeviceId = yield NativeModules.DeviceInfoProvider.getAnonymousDeviceId()
        .catch((e) => {
        logger.error(`Error in NativeModules.DeviceInfoProvider.getAnonymousDeviceId():${JSON.stringify(e)}`);
    });
    if (anonymousDeviceId) {
        amplifyConfig.AWSPinpoint.endpoint.userId = anonymousDeviceId;
    }
    return amplifyConfig;
});
const configureAmplify = (bundleVersion) => __awaiter(void 0, void 0, void 0, function* () {
    if (configured()) {
        return;
    }
    if (Platform.OS === 'web') {
        DeviceInfo.setVersion(bundleVersion);
    }
    const amplifyConfiguration = yield constructAmplifyConfiguration(bundleVersion);
    Amplify.configure(amplifyConfiguration);
    Auth.configure(amplifyConfiguration);
    setConfigured(true);
});
const putMetric = (eventMetric) => {
    var _a;
    (_a = Analytics.record(eventMetric)) === null || _a === void 0 ? void 0 : _a.catch((e) => {
        logger.error(`Error in Analytics.record(${JSON.stringify(eventMetric)}): ${JSON.stringify(errorToLogObject(e))}`);
    });
};
const putAndLogMetric = (tenantId, logLevel, eventMetric) => {
    putMetric(eventMetric);
    const { name, attributes, metrics } = eventMetric;
    AZLogTenant(logLevel, name, tenantId, Object.assign(Object.assign({}, attributes), { maxBackendLogLevel: logLevel, metrics }));
};
const Metric = (eventName, tenantId, options) => {
    // For more info on how metricName differs from eventName, see this example in the Amplify docs:
    // https://docs.amplify.aws/lib/analytics/record/q/platform/js#record-engagement-metrics
    const metricName = (options === null || options === void 0 ? void 0 : options.metricName) || eventName;
    const metricAttributes = MetricAttributes(options === null || options === void 0 ? void 0 : options.attributes);
    metricAttributes.mergeAttributes(GlobalMetricAttributes.toAttributes());
    const attributes = metricAttributes.toStringAttributes();
    const v = options === null || options === void 0 ? void 0 : options.value;
    const includedValidValue = (v !== undefined) && (v !== null) && !Number.isNaN(+v);
    const value = includedValidValue ? Number(v) : 1;
    function toMetric() {
        return {
            name: `${tenantId}.${eventName}`,
            attributes,
            metrics: { [`${tenantId}.${metricName}`]: value },
        };
    }
    return {
        put() {
            if (!eventName) {
                return;
            }
            if (!tenantId) {
                return;
            }
            putMetric(toMetric());
        },
        putAndLog(logLevel = LogLevel.Debug) {
            if (!eventName) {
                return;
            }
            if (!tenantId) {
                return;
            }
            putAndLogMetric(tenantId, logLevel, toMetric());
        },
    };
};
export { Metric, configureAmplify, setConfigured };
//# sourceMappingURL=Metric.js.map